var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-breadcrumb',_vm._b({},'b-breadcrumb',_vm.$attrs,false),[(_vm.startWithHome)?_c('b-breadcrumb-item',{attrs:{"to":"/home"}},[_c('BaseIcon',{attrs:{"name":"home"}})],1):_vm._e(),_vm._l((_vm.items),function(item,index){return _c('b-breadcrumb-item',{key:index,attrs:{"active":_vm.isLast(index)},on:{"click":function () {
        if (item.routeInfo) {
          var routeInfo = item.routeInfo
          routeInfo.params.beforeScreenRouteInfo = item.beforeScreenRouteInfo
          _vm.$router.push(routeInfo)
        }
      }}},[_vm._v(" "+_vm._s(item.name))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }